module.exports = __webpack_public_path__ + "img/Four_Towers_-_PE_-t-17164-s004.694bf212.jpg";